export function getMostRecentCRMEvent(company) {
    if(company.crm_actions) {
        let crmActionsByDate = company.crm_actions.filter(action => {return action.campaign_id == company.campaign.id}).sort(function(a,b) {
            return new Date(b.resolved_date) - new Date(a.resolved_date)
        })
        if(crmActionsByDate.length > 0) {
            return crmActionsByDate[0]
        }
    } else {
        return null
    }
}

export function getAutoComputedCRMEvent(company) {
    // console.log('getAutoComputedCRMEvent')
    if(company.crm_actions) {
        let crmEventTypeIDs = company.crm_actions.filter(action => {return action.campaign_id == company.campaign.id}).map((action) => action.action.id)
        // console.log(crmEventTypeIDs)
        let crmEventsByOrdinal = company.crm_actions.filter(action => {return action.campaign_id == company.campaign.id}).sort(function(a,b) {
            return b.action.ordinal - a.action.ordinal
        })
        // console.log(crmEventsByOrdinal)
        if(crmEventTypeIDs.length > 0) {
            if(crmEventTypeIDs.includes(28)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 28)
            } else if(crmEventTypeIDs.includes(29)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 29)
            } else if(crmEventTypeIDs.includes(20)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 20)
            } else if(crmEventTypeIDs.includes(27)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 27)
            } else if (crmEventTypeIDs.includes(18)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 18)
            } else if (crmEventTypeIDs.includes(17)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 17)
            } else if (crmEventTypeIDs.includes(16)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 16)
            } else if (crmEventTypeIDs.includes(15)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 15)
            } else if (crmEventTypeIDs.includes(14)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 14)
            } else if (crmEventTypeIDs.includes(13)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 13)
            } else if (crmEventTypeIDs.includes(12)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 12)
            } else if (crmEventTypeIDs.includes(11)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 11)
            } else if (crmEventTypeIDs.includes(10)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 10)
            } else if (crmEventTypeIDs.includes(9)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 9)
            } else if (crmEventTypeIDs.includes(22)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 22)
            } else if (crmEventTypeIDs.includes(32)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 32)
            } else if (crmEventTypeIDs.includes(8)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 8)
            } else if (crmEventTypeIDs.includes(6)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 6)
            } else if (crmEventTypeIDs.includes(7)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 7)
            } else if (crmEventTypeIDs.includes(5)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 5)
            } else if (crmEventTypeIDs.includes(1)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 1)
            } else if (crmEventTypeIDs.includes(21)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 21)
            } else if (crmEventTypeIDs.includes(4)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 4)
            } else if (crmEventTypeIDs.includes(3)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 3)
            } else if (crmEventTypeIDs.includes(2)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 2)
            } else if (crmEventTypeIDs.includes(19)) {
                return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == 19)
            } else {
                return null
            }
            // return crmActionsByOrdinal[0]
        } else {
            return null
        }
    } else {
        return null
    }
}

export function getDefaultReportedCRMEvent(company) {
    function assignDefaultCRMEvent(crmEventTypeIDs, crmEventsByOrdinal, actionId) {
        if(crmEventTypeIDs.includes(actionId)) {
            return crmEventsByOrdinal.find((crmEvent) => crmEvent.action.id == actionId)
        }
    }

    if(company.crm_actions) {
        // let crmEventTypeIDs = company.crm_actions.filter(action => {return action.campaign_id == company.campaign.id && action.show_on_crm_report == true}).map((action) => action.action.id)
        // console.log(crmEventTypeIDs)
        let crmEventsByOrdinal = company.crm_actions.filter(action => {return action.campaign_id == company.campaign.id && action.show_on_crm_report == true}).sort(function(a,b) {
            return b.action.ordinal - a.action.ordinal
        })
        let crmEventTypeIDs = crmEventsByOrdinal.map((event) => event.action.id)
        // console.log(crmEventsByOrdinal)
        if(crmEventTypeIDs.length > 0) {
            const orderedActionIds = [
                29, // Dead - Out Of Business -- Dead
                28, // Dead - Acquired -- Dead
                41, // Other: Dead -- Dead
                20, // Client Pass -- CLient Pass
                27, // Not Interested -- Not Interested
                18, // Transaction Closed -- Transaction Closed
                26, // Revisit / Cut -- Revisit / Cut
                25, // Not Now / Keep Warm -- Not Now / Keep Warm
                45, // Periodic Check-In
                17, // LOI Executed -- Under LOI
                16, // LOI Submitted -- Active - In Dialogue
                15, // IOI Submitted -- IOI Submitted * ACTIVE IN DIALOGUE?
                24, // Active High Priority -- Active - In Dialogue
                33, // Received Materials -- Active - In Dialogue
                14, // Preliminary Info Request Sent -- Active - In Dialogue
                13, // NDA Executed -- Active - In Dialogue
                12, // NDA Sent for Review -- Active - In Dialogue
                34, // Follow up on DQ -- Active - In Dialogue
                35, // Follow up on NDA -- Active - In Dialogue
                11, // In-Person Client Meeting / Facility Tour -- Active - In Dialogue
                10, // Client Call/Zoom -- Active - In Dialogue
                9, // Shedd Call/Zoom -- Active - In Dialogue
                38, // Schedule In-Person Meeting -- Active - In Dialogue
                39, // Schedule Client Call/Zoom -- Active - In Dialogue
                40, // Schedule Shedd Call/Zoom -- Active - In Dialogue
                22, // Additional Response / Target Reached Back Out
                8, // Initial Response - Active - In Dialogue
                42, // Other: Active - In Dialogue -- Active - In Dialogue
                31, // Responded / Coverage -- Responded / Coverage
                6, // Cold Call Success -- Responded / Coverage
                7, // LinkedIn DM -- No Response
                32, // Sent Text to Mobile -- No Response
                5, // Cold Call Attempt -- No Response
                21, // Email 4 -- No Response
                4, // Email 3 -- No Response
                3, // Email 2 -- No Response
                2, // Email 1 -- No Response
                1, // Email Sent -- No Response
                43, // Other: No Response -- No Response
                44, // Other: Not Contacted -- Not Contacted
                36, // Next Step Needed -- No Mapping
                23, // Hold -- No Mapping
                19, // Other -- No Mapping
            ]
            let defaultEventID = null
            for(let i = 0; i < orderedActionIds.length - 1; i++) {
                let returnedEventID = assignDefaultCRMEvent(crmEventTypeIDs, crmEventsByOrdinal, orderedActionIds[i])
                if(returnedEventID) {
                    defaultEventID = returnedEventID
                    break
                }
            }
            return defaultEventID
        }
    }

    return null
}

// Details that record something coming back from the target or the client --
// none of our users did that work, so these save with no user assigned.
// Matched on the name so it holds for detail types added later; the names are
// prefixes because a type can carry a longer name (Additional Response /
// Target Reached Back Out).
const responseCRMDetailTypeNames = [
    'Initial Response',
    'Additional Response',
    'Client Response',
    'Received Materials',
]

export function isResponseCRMDetailType(crmDetailType) {
    if(!crmDetailType) {
        return false
    }
    const names = [crmDetailType.action_name, crmDetailType.resolved_label, crmDetailType.unresolved_label]
    return responseCRMDetailTypeNames.some((responseName) => {
        return names.some((name) => name && name.trim().toLowerCase().startsWith(responseName.toLowerCase()))
    })
}

export function getCRMStatusGroups() {
    return [
        {label: 'No Response', ordinal: 1},
        {label: 'Responded / Coverage', ordinal: 2},
        {label: 'Active - In Dialogue', ordinal: 3},
        {label: 'IOI Submitted', ordinal: 4},
        {label: 'Under LOI', ordinal: 5},
        {label: 'Transaction Closed', ordinal: 6},    
        {label: 'Not Now / Keep Warm', ordinal: 7},
        {label: 'Revisit / Cut', ordinal: 8},
        {label: 'Not Interested', ordinal: 9},
        {label: 'Client Pass', ordinal: 10},
        {label: 'Dead', ordinal: 11},
        {label: 'Not Contacted', ordinal: 12},
    ]
}

export function getComputedCRMStatusByEventId(crmEventId) {
    // if(crmEventId == 45) {
    //     console.log(crmEventId)
    // }
    // console.log('getComputedCRMStatusByEventId', crmEventId)
    const crmEventToStatusMapping = {
        28: {label: 'Dead', value: 11},
        29: {label: 'Dead', value: 11},
        41: {label: 'Dead', value: 11},
        20: {label: 'Client Pass', value: 9},
        27: {label: 'Not Interested', value: 10},
        18: {label: 'Transaction Closed', value: 0},
        26: {label: 'Revisit / Cut', value: 8},
        25: {label: 'Not Now / Keep Warm', value: 7},
        45: {label: 'Not Now / Keep Warm', value: 7},
        17: {label: 'Under LOI', value: 1},
        16: {label: 'Active - In Dialogue', value: 3},
        15: {label: 'IOI Submitted', value: 2},
        24: {label: 'Active - In Dialogue', value: 3},
        33: {label: 'Active - In Dialogue', value: 3},
        14: {label: 'Active - In Dialogue', value: 3},
        13: {label: 'Active - In Dialogue', value: 3},
        12: {label: 'Active - In Dialogue', value: 3},
        34: {label: 'Active - In Dialogue', value: 3},
        35: {label: 'Active - In Dialogue', value: 3},
        11: {label: 'Active - In Dialogue', value: 3},
        9: {label: 'Active - In Dialogue', value: 3},
        38: {label: 'Active - In Dialogue', value: 3},
        39: {label: 'Active - In Dialogue', value: 3},
        22: {label: 'Active - In Dialogue', value: 3},
        8: {label: 'Active - In Dialogue', value: 3},
        42: {label: 'Active - In Dialogue', value: 3},
        46: {label: 'Active - In Dialogue', value: 3},
        47: {label: 'Active - In Dialogue', value: 3},
        48: {label: 'Active - In Dialogue', value: 3},
        49: {label: 'Active - In Dialogue', value: 3},
        50: {label: 'Active - In Dialogue', value: 3},
        51: {label: 'Active - In Dialogue', value: 3},
        31: {label: 'Responded / Coverage', value: 6},
        6: {label: 'Responded / Coverage', value: 6},
        7: {label: 'No Response', value: 4},
        32: {label: 'No Response', value: 4},
        5: {label: 'No Response', value: 4},
        21: {label: 'No Response', value: 4},
        4: {label: 'No Response', value: 4},
        3: {label: 'No Response', value: 4},
        2: {label: 'No Response', value: 4},
        1: {label: 'No Response', value: 4},
        43: {label: 'No Response', value: 4},
        44: {label: 'Not Contacted', value: 5},
    }
    if(crmEventId && crmEventToStatusMapping[crmEventId]) {
        return crmEventToStatusMapping[crmEventId]
    } else {
        return {
            label: 'Not Contacted',
            value: 5,
        }
    }
}

export function getDefaultProgressUpdateByDate(company, date) {
    if(company.crm_event_notes && company.crm_event_notes.length > 0) {
        if(company.crm_event_notes.filter((event_note) => event_note.date == date).length > 0) {
            return company.crm_event_notes.filter((event_note) => event_note.date == date)[0]
        }
    }
     return null
}

// CRM details are grouped by date -- resolved details newest date first, open
// details soonest due date first -- and the ordinal decides the order within a
// group. Ordinals are only written when a list is saved or dragged and the
// backend defaults a brand new detail to 0, so no ordinal means the detail
// hasn't been given a slot in its group yet.
function getOrdinalValue(crmDetail) {
    const ordinal = parseFloat(crmDetail.ordinal)
    return Number.isFinite(ordinal) && ordinal > 0 ? ordinal : null
}

// Details that were never ordered fall back to creation order. created_at is a
// date and not a timestamp, so it can't separate two details entered on the
// same day -- the id does that. Unsaved rows have no created_at and a random
// negative id, so they go by the order they were added to the form instead.
function compareCRMDetailsByOldestFirst(a, b) {
    if(a.creation_sequence && b.creation_sequence) {
        return a.creation_sequence - b.creation_sequence
    } else if(a.creation_sequence) {
        return 1
    } else if(b.creation_sequence) {
        return -1
    }
    const createdDifference = new Date(a.created_at) - new Date(b.created_at)
    if(createdDifference) {
        return createdDifference
    }
    return a.id - b.id
}

function compareCRMDetailsByCreationOrder(a, b, newestFirst) {
    const oldestFirst = compareCRMDetailsByOldestFirst(a, b)
    return newestFirst ? -oldestFirst : oldestFirst
}

// Resolved details run newest first, so an unordered detail is the newest one
// in its group and belongs on top of it. Open details run soonest due date
// first, so there an unordered detail belongs at the bottom.
function compareCRMDetailsWithinDateGroup(a, b, newestFirst) {
    const aOrdinal = getOrdinalValue(a)
    const bOrdinal = getOrdinalValue(b)
    if(aOrdinal && bOrdinal) {
        return aOrdinal - bOrdinal || compareCRMDetailsByCreationOrder(a, b, newestFirst)
    } else if(aOrdinal) {
        return newestFirst ? 1 : -1
    } else if(bOrdinal) {
        return newestFirst ? -1 : 1
    }
    return compareCRMDetailsByCreationOrder(a, b, newestFirst)
}

export function sortCRMDetailsByResolvedDate(a, b) {
    if(a.resolved_date && b.resolved_date){
        if(a.resolved_date == b.resolved_date){
            return compareCRMDetailsWithinDateGroup(a, b, true)
        } else {
            return new Date(b.resolved_date) - new Date(a.resolved_date)
        }
    } else if (a.resolved_date && !b.resolved_date){
        return -1
    } else if (b.resolved_date && !a.resolved_date){
        return 1
    } else {
        return compareCRMDetailsWithinDateGroup(a, b, true)
    }
}

export function sortCRMDetailsByDueDate(a, b) {
    if(a.due_date && b.due_date){
        if(a.due_date == b.due_date){
            return compareCRMDetailsWithinDateGroup(a, b, false)
        } else {
            return new Date(a.due_date) - new Date(b.due_date)
        }
    } else if (a.due_date && !b.due_date){
        return 1
    } else if (b.due_date && !a.due_date){
        return -1
    } else {
        return compareCRMDetailsWithinDateGroup(a, b, false)
    }
}

// Ordinals are written 1-based so that 0 -- the value the backend gives a
// detail created outside of the CRM detail form -- keeps meaning "not ordered
// yet" and leaves that detail sorting by when it was created.
export function assignCRMDetailOrdinals(crmDetails) {
    for(let i = 0; i < crmDetails.length; i++){
        crmDetails[i].ordinal = i + 1
    }
}

let lastCreationSequence = 0

// Unsaved rows get a counter instead of relying on where they sit in the array,
// so a group of new details always saves in the order they were added.
export function getNextCreationSequence() {
    lastCreationSequence += 1
    return lastCreationSequence
}
